import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { PlantapiService } from './plantapi.service';
import { APIs } from 'src/app/config/api.constant';
import { AppConstant } from '../config/app.constant';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { environment } from '../../environments/environment';
const baseUrl = `${environment.apiBaseUrlVegitation}api/`;

@Injectable({
  providedIn: 'root'
})
export class AddplantService {
  url: string;
  accessToken: any;
  token_type: any;
  token: string;
  excelContent: any;

  constructor(private apiService: PlantapiService, private http: HttpClient) {

  }

  createPlantVegitation(body?: any): Observable<any> {
    return this.apiService.post(APIs.createPlantVegkitation, body).pipe(map(response => {
      return response;
    }));
  }

  updatePlantVegitation(body?: any): Observable<any> {
    return this.apiService.post(APIs.updatePlantVegkitation, body).pipe(map(response => {
      return response;
    }));
  }
}